import Homepage from './homepage';

export default {
  Homepage
}
